import api from './api'

const adminDataProvider = {
    getTeamtaskData(params = {}) {
        return api.query('crmtt/api/Board/GetBoardAdmin', {
            params,
        })
    },
    updateSuperADmin(params = {}) {
        return api.put('/crmtt/api/Board/UpdateBoard', params)
    },
    getAllTeamtasks(params = {}) {
        return api.post('/crmtt/api/Table/List', params)
    },
    addTable(params) {
        return api.post(`crmtt/api/Table/Add?id=${params}`)
    },
    getEpicList() {
        return api.get('crmtt/api/Epic/List')
    },
}

// const kanabanBoarDataProvider = {
//   getKanbanData(params = {}) {
//     return api.query('crmtt/api/Board/BoardColumn', {
//       params,
//     })
//   },
// }

export default adminDataProvider
